import { formatInTimeZone } from 'date-fns-tz'

import type { CanteenRatingGroup, CanteenRatingItem } from './types'

/** The meal day as the canteen saw it, not as the browser reads it. */
export const localDayOf = (item: CanteenRatingItem) =>
  formatInTimeZone(new Date(item.date), item.timezone, 'yyyy-MM-dd')

/** Groups by day + vendor, keeping the server's arrival-time order. */
export const groupItems = (items: CanteenRatingItem[]): CanteenRatingGroup[] => {
  const groups = new Map<string, CanteenRatingGroup>()

  for (const item of items) {
    const localDay = localDayOf(item)
    const key = `${localDay}|${item.vendorId}`
    const existing = groups.get(key)

    if (existing) {
      existing.items.push(item)
      continue
    }

    groups.set(key, {
      key,
      localDay,
      timezone: item.timezone,
      vendorName: item.vendorName,
      items: [item],
    })
  }

  return [...groups.values()]
}
